module.exports = __webpack_public_path__ + "static/media/mma.9eee31b2.webp";